import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import axios from "axios";
import moment from "jalali-moment";
import ReactApexChart from "react-apexcharts";

function Report({ bar, BaseUrl }) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
    HttpOnly: true,
  };
  const [open, setOpen] = useState(1);
  const [series, setseries] = useState([
    {
      name: "series1",
      data: [31, 40, 28, 51, 42, 109, 100],
    },
    {
      name: "series2",
      data: [11, 32, 45, 32, 34, 52, 41],
    },
  ]);
  const [options, setoptions] = useState({
    chart: {
      height: 100,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00.000Z",
        "2018-09-19T01:30:00.000Z",
        "2018-09-19T02:30:00.000Z",
        "2018-09-19T03:30:00.000Z",
        "2018-09-19T04:30:00.000Z",
        "2018-09-19T05:30:00.000Z",
        "2018-09-19T06:30:00.000Z",
      ],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  });
  const [Allphones, setAllphones] = useState([]);
  const [AllReports, setAllReports] = useState([]);

  const getdataphone = () => {
    axios
      .get(`${BaseUrl}/phone/all`, { headers: headers })
      .then((res) => {
        setAllphones(res.data);
        console.log(res.data, "lllllllllkkkkjjjhhhgg");
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getdataphone();
  }, []);
  const handleOpen = (value, id) => {
    console.log(value);

    setOpen(open === value ? 0 : value);
    axios(`${BaseUrl}/report/${id}`, { headers: headers })
      .then((res) => {
        setAllReports(res.data);
        console.log(res.data, "lllllllllkkkkjjjhhhgg");
      })
      .catch((error) => {});
  };
  return (
    <div
      className={`${
        bar ? "md:block  col-span-10 mr-16" : "md:block  col-span-11 mr-10"
      }`}
    >
      <div className="text-4xl  text-orange-700 mb-5 w-1/6 rounded-l-xl bg-slate-700 text-center relative left-8 p-1 mt-10">
        تولید نرم افزار
      </div>
      <div
        style={{ direction: "rtl" }}
        class="w-full  bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2  m-auto"
        role="alert"
      >
        {Allphones?.Phones &&
          Allphones?.Phones.map((item, index) => {
            return (
              <>
              <Accordion open={open === index + 1}>
                <AccordionHeader
                  onClick={() => handleOpen(index + 1, item.ANDROID_ID)}
                >
                  {item.ANDROID_ID}/{item.DeviceUserName}
                </AccordionHeader>
                {AllReports?.Reports &&
                  AllReports?.Reports.map((item, index) => {
                    return (
                      <AccordionBody>
                        <table class="w-1/2 text-sm text-left text-gray-500 dark:text-gray-400">
                          <thead class="text-xs text-white uppercase bg-gradient-to-r from-sky400 to-sky700 dark:bg-gray-700 dark:text-gray-400 ">
                            <tr>
                              <th
                                scope="col"
                                class="px-6 py-3 text-xl text-center"
                              >
                                ردیف
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-xl text-center"
                              >
                                تاریخ و زمان اتصال
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              key={index}
                              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                            >
                              <td class="w-32 py-4 text-center">{index + 1}</td>
                              <td class="w-32 py-4 text-center">
                                {moment
                                  .from(item.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                                  .locale("fa")
                                  .format("YYYY-MM-DD HH:mm:ss")}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    );
                  })}
              </Accordion>
              <ReactApexChart
              options={options}
              series={series}
              type="area"
              height={250}
            />
              </>
              
            );
          })}


      </div>
    </div>
  );
}

export default Report;
